import apiFetch from '../apiFetch'
export default function (dossierStageId, token, body) {
  return apiFetch({ endPoint: `conditionNoDocumental/All/Other/${dossierStageId}`, method: 'POST', body: body, token: token })
}
